/**
 * Synthetic `CompanyProfileData.domain` prefix for marketplace audience groups
 * keyed by `organizationToken` (see `useAudiencesData`, `AudiencesPage`, `AudienceStep`).
 */
export const MARKETPLACE_ORG_DOMAIN_PREFIX = '__org__:'

/**
 * Bucket token when `organizationToken` is missing; grouped audiences share one section.
 */
export const MARKETPLACE_ORGANIZATION_UNKNOWN_TOKEN = '__unknown_org__'
